<template>
  <div class="relative flex flex-col space-y-2">
    <label for="cpf" class="text-sm text-gray-400">
      {{ label }}
    </label>
    <div class="relative w-full">
      <input
        class="w-full text-sm"
        v-mask="mask"
        :name="name"
        :type="type"
        :placeholder="placeholder"
        :value="value"
        :class="[
          !error
            ? 'focus:ring-ontick-blue-600 focus:ring-1'
            : 'ring-ontick-red-600 focus:ring-ontick-red-600 ring-2 focus:ring-2',
          locked
            ? 'border-0 bg-transparent text-gray-400'
            : 'bg-ontick-steel-500  rounded border-0 shadow focus:outline-none',
        ]"
        :maxlength="maxlength"
        :autocomplete="autocomplete"
        :disabled="disabled || locked"
        @input="$emit('input', $event.target.value)"
      />
      <div class="absolute top-1/2 right-2 -translate-y-1/2" v-if="loading">
        <i v-html="$icons.loading" class="text-ontick-blue-600"></i>
      </div>
    </div>
    <span class="text-ontick-red-600 text-xs" v-if="errorMessage && error">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
    },
    errorMessage: {
      type: String,
    },
    label: {
      type: String,
    },
    value: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    mask: {
      type: String,
    },
    maxlength: {
      type: Number,
    },
    type: {
      type: String,
      default: "text",
    },
    name: {
      type: String,
    },
    autocomplete: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    locked: {
      type: Boolean,
    },
  },

  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    },
  },

  computed: {
    error() {
      return !!this.errorMessage;
    },
  },
};
</script>

<style></style>
